import React from "react"
import cn from "classnames"
import { colormapAt } from "../shared/colormap"
import {
    RADAR_DBZ_COLOR_STOPS,
    RADAR_FADE_IN_MAX_DBZ,
    RADAR_FADE_IN_MIN_DBZ,
    RADAR_HEATMAP_MAX_DBZ,
} from "./RadarHeatmapLayer"

const BASE_TICKS_DBZ = [0, 10, 20, 30, 40, 50, 60] as const

const cssRgba = (c: readonly [number, number, number], alpha: number): string =>
    `rgba(${Math.round(c[0] * 255)}, ${Math.round(c[1] * 255)}, ${Math.round(c[2] * 255)}, ${alpha})`

const cssRgb = (c: readonly [number, number, number]) => cssRgba(c, 1)

const AXIS_MIN_DBZ = RADAR_FADE_IN_MIN_DBZ
const AXIS_RANGE_DBZ = RADAR_HEATMAP_MAX_DBZ - AXIS_MIN_DBZ

const pctOf = (dbz: number) => (((dbz - AXIS_MIN_DBZ) / AXIS_RANGE_DBZ) * 100).toFixed(2)

const colorAt = (dbz: number) => colormapAt(dbz, RADAR_DBZ_COLOR_STOPS)

const radarGradientCss = [
    `${cssRgba(colorAt(AXIS_MIN_DBZ), 0)} 0%`,
    `${cssRgb(colorAt(RADAR_FADE_IN_MAX_DBZ))} ${pctOf(RADAR_FADE_IN_MAX_DBZ)}%`,
    ...RADAR_DBZ_COLOR_STOPS.filter((s) => s.value > RADAR_FADE_IN_MAX_DBZ).map(
        (s) => `${cssRgb(s.color)} ${pctOf(s.value)}%`
    ),
].join(", ")

export const RadarLegend = ({ isLight }: { isLight: boolean }) => {
    const textColor = cn({ ["text-white"]: !isLight, ["text-black"]: isLight })
    return (
        <div className="flex items-end gap-2">
            <div>
                <div
                    className={cn("h-2 w-[230px] rounded border", {
                        ["bg-gray-300 border-black-500"]: isLight,
                        ["bg-gray-600 border-white-500"]: !isLight,
                    })}
                    style={{ background: `linear-gradient(to right, ${radarGradientCss})` }}
                />
                <div className="relative mt-1 h-3 w-[230px]">
                    {BASE_TICKS_DBZ.map((v) => (
                        <span
                            key={v}
                            className={cn(
                                "absolute -translate-x-1/2 font-mono text-[10px] leading-none",
                                textColor
                            )}
                            style={{ left: `${pctOf(v)}%` }}
                        >
                            {v}
                        </span>
                    ))}
                </div>
            </div>
            <span className={cn("whitespace-nowrap text-xs leading-none", textColor)}>dBZ</span>
        </div>
    )
}
